export const common = {
  siteName: 'CSSBuy Spreadsheet',
  siteDomain: 'cssbuybr.run',
  mainSite: 'https://kaspreadsheet.com',
  language: 'English',
  nav: {
    home: 'Home',
    products: 'Products',
    guides: 'Guides',
    review: 'Review',
    shipping: 'Shipping',
    qc: 'QC',
    warehouse: 'Warehouse',
    sellers: 'Sellers',
    comparisons: 'Comparisons',
    safety: 'Safety',
    about: 'About',
    contact: 'Contact',
  },
  buttons: {
    explore: 'Explore CSSBuy Spreadsheet',
    buyNow: 'Buy It Now',
    viewGuides: 'View Buying Guides',
    mainSite: 'CSSBuy Spreadsheet',
    shopNow: 'Shop Now',
    readMore: 'Read More',
    backToHome: 'Back to Home',
  },
  categories: {
    title: 'Product Categories',
    subtitle: 'Browse trusted products by category on our main site',
    shoes: 'Shoes',
    hoodiesSweaters: 'Hoodies / Sweaters',
    tShirts: 'T-Shirts',
    jackets: 'Jackets',
    pantsShorts: 'Pants / Shorts',
    headwear: 'Headwear',
    sets: 'Sets',
    underwear: 'Underwear / Underpants',
    jersey: 'Jersey',
    accessories: 'Accessories',
    bags: 'Bags',
    belts: 'Belts',
    perfumes: 'Perfumes',
    otherStuff: 'Other Stuff',
  },
  hero: {
    h1: 'CSSBuy Spreadsheet: Find Products, Sellers & Buying Guides',
    description:
      'Looking for a CSSBuy Spreadsheet to find products, sellers, and shopping resources more easily? Discover guides, comparisons, QC info, warehouse details, shipping tips, and practical advice to research better before you buy.',
  },
  popularResources: {
    title: 'Popular Resources',
    subtitle: 'Everything you need to know about CSSBuy',
    items: {
      spreadsheet: 'CSSBuy Spreadsheet',
      review: 'CSSBuy Review',
      shipping: 'CSSBuy Shipping Cost',
      coupon: 'CSSBuy Coupon',
      discount: 'CSSBuy Discount Code',
      warehouse: 'CSSBuy Warehouse',
      legit: 'CSSBuy Legit',
      qc: 'CSSBuy QC',
      sellers: 'CSSBuy Sellers',
    },
  },
  ctaSection: {
    title: 'Ready to Start Shopping?',
    description:
      'Visit our main store to browse the full CSSBuy Spreadsheet with verified products, trusted sellers, and exclusive deals.',
    button1: 'CSSBuy Spreadsheet',
    button2: 'Buy It Now',
  },
  footer: {
    disclaimer:
      'This website is an independent informational resource and is not officially affiliated with or endorsed by CSSBuy.',
    quickLinks: 'Quick Links',
    resources: 'Resources',
    legal: 'Legal',
    editorial: 'Editorial Policy',
    disclaimerPage: 'Disclaimer',
    privacy: 'Privacy Policy',
    terms: 'Terms of Service',
    copyright: '© {year} cssbuybr.run. All rights reserved.',
  },
  article: {
    published: 'Published',
    updated: 'Updated',
    minRead: 'min read',
    tableOfContents: 'Table of Contents',
    relatedArticles: 'Related Articles',
    faq: 'Frequently Asked Questions',
  },
  home: {
    latestGuides: 'Latest Guides',
    latestGuidesSubtitle: 'Explore our in-depth guides and resources for smarter shopping',
    pillarTitle: 'CSSBuy Spreadsheet Guides',
    pillarSubtitle: 'In-depth pillar articles to help you shop smarter with CSSBuy',
  },
  meta: {
    homeTitle: 'CSSBuy Spreadsheet: Products, Sellers & Buying Guides 2026',
    homeDescription:
      'The complete CSSBuy Spreadsheet resource hub. Find products, sellers, QC guides, shipping info, warehouse details, and buying tips for CSSBuy in 2026.',
  },
  products: {
    title: 'Featured Products',
    subtitle: 'Browse curated products from our main spreadsheet. Click any item to view details and purchase on our partner site.',
    viewAll: 'View All Products',
    pageTitle: 'All Products',
    pageDescription: 'Browse all curated products from our spreadsheet. Click any item to view details and purchase on our partner site.',
    items: 'products',
    categories: 'categories',
    all: 'All',
  },
};